import React, { useEffect, useRef, useState } from 'react';
import BasicTemplate from 'components/Toast/BasicTemplate';
import { toast } from 'react-toastify';
import {
  uploadFile as uploadS3File,
  deleteFile as deleteS3File,
  dowloadFile
} from 'services/files/s3FileService';
import {
  mapFile,
  getFiles,
  deleteFile,
  getByRecordIdFiles
} from 'services/files/attachmentService';

const useUploadByRecordValue = (
  documentFolderParam,
  recordValue,
  app,
  recordId = 0
) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [itemDownLoading, setItemDownLoading] = useState(-1);
  const [itemPrinting, setItemPrinting] = useState(-1);
  const [itemDeleting, setItemDeleting] = useState(-1);
  const [documentFolder, setDocumentFolder] = useState(documentFolderParam);
  const fileInputRef = useRef(null);
  useEffect(() => {
    setDocumentFolder(prev =>
      prev === documentFolderParam ? prev : documentFolderParam
    );
  }, [documentFolderParam]);

  // Load files when recordValue or app changes
  useEffect(() => {
    if (recordValue) {
      loadFiles();
    }
  }, [recordValue, app, documentFolder]);

  const loadFiles = async () => {
    try {
      const response = await getFiles(recordValue, app);
      console.log(response);
      if (response?.data?.data) {
        let inMainFolderFiles = response.data.data.filter(x => !x.path);
        setUploadedFiles(inMainFolderFiles);
      }
    } catch (error) {
      console.error('Error loading files:', error);
    }
  };

  const handleFileChange = e => {
    console.log(e.target.files[0]);
    setSelectedFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!selectedFile) return;

    setIsLoading(true);
    try {
      const res = await uploadS3File(
        encodeURIComponent(documentFolder),
        selectedFile
      );
      console.log(res);
      if (
        res.status === 200 &&
        res.data.success === true &&
        res.data.mappings?.length > 0
      ) {
        const item = res.data.mappings[0];
        await mapFile([
          {
            Name: item.originalName,
            App: app,
            RecordID: recordId,
            RecordValue: recordValue,
            TempName: item.hashedName,
            Path: '',
            Type: ''
          }
        ]);
        console.log('mapped');
      } else {
        console.log('map failure');
      }
      setSelectedFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = null; // Clear input file
      }
      loadFiles();
    } catch (error) {
      console.error('Error uploading file:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const onFileDownload = async index => {
    setItemDownLoading(index);
    try {
      if (!uploadedFiles || uploadedFiles.length <= index) {
        toast.error(<BasicTemplate success={false} text={'File not found!'} />);
        return;
      }
      const file = uploadedFiles[index];
      const response = await dowloadFile(documentFolder + '/' + file.tempName);
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const downloadLink = document.createElement('a');
      downloadLink.href = url;
      downloadLink.download = file.name;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
      console.error('Error downloading file:', error);
      toast.error(<BasicTemplate success={false} text={'Download failed!'} />);
    } finally {
      setItemDownLoading(-1);
    }
  };

  const onFileDelete = async index => {
    setItemDeleting(index);
    try {
      if (!uploadedFiles || uploadedFiles.length <= index) {
        toast.error(<BasicTemplate success={false} text={'File not found!'} />);
        return;
      }
      const file = uploadedFiles[index];
      const res = await deleteFile({
        app,
        recordValue,
        tempName: file.tempName
      });
      await deleteS3File(documentFolder + '/' + file.tempName);
      if (res.status === 200 && res.data.success === true) {
        toast.success(<BasicTemplate success={true} text={'Success!'} />);
        loadFiles();
      }
      console.log(res);
    } catch (error) {
      console.error('Error deleting file:', error);
    } finally {
      setItemDeleting(-1);
    }
  };

  const onFilePrint = async index => {
    setItemPrinting(index);
    try {
      if (!uploadedFiles || uploadedFiles.length <= index) {
        toast.error(<BasicTemplate success={false} text={'File not found!'} />);
        return;
      }
      const file = uploadedFiles[index];
      const response = await dowloadFile(documentFolder + '/' + file.tempName);
      console.log(response);
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);

      const printWindow = window.open(url, '_blank');
      if (printWindow) {
        printWindow.onload = function () {
          printWindow.focus();
          printWindow.print();
        };
      } else {
        toast.error(<BasicTemplate success={false} text={'Popup blocked!'} />);
      }
    } catch (error) {
      console.error('Error printing file:', error);
      toast.error(<BasicTemplate success={false} text={'Print failed!'} />);
    } finally {
      setItemPrinting(-1);
    }
  };

  return {
    selectedFile,
    uploadedFiles,
    isLoading,
    itemDownLoading,
    itemDeleting,
    documentFolder,
    fileInputRef,
    itemPrinting,
    handleFileChange,
    handleUpload,
    onFileDownload,
    onFileDelete,
    onFilePrint,
    loadFiles
  };
};

const useDownloadByTraineeFiles = (documentFolderParam, recordId, app) => {
  const [uploadedFiles, setUploadedFiles] = useState(null);
  const [itemDownLoading, setItemDownLoading] = useState(-1);
  const [documentFolder, setDocumentFolder] = useState(documentFolderParam);

  useEffect(() => {
    setDocumentFolder(documentFolderParam);
  }, [documentFolderParam]);

  console.log('d' + documentFolderParam);
  useEffect(() => {
    if (recordId) {
      loadFiles();
    }
  }, [recordId, app]);

  const loadFiles = async () => {
    try {
      const response = await getByRecordIdFiles(recordId, app);

      if (response?.data?.data) {
        setUploadedFiles(response.data.data);
      } else {
        console.log('err loading');
      }
    } catch (error) {
      console.error('Error loading files:', error);
    }
  };

  const onFileDownload = async index => {
    setItemDownLoading(index);
    try {
      if (!uploadedFiles || uploadedFiles.length <= index) {
        toast.error(<BasicTemplate success={false} text={'File not found!'} />);
        return;
      }
      const file = uploadedFiles[index];
      const response = await dowloadFile(
        documentFolder + '/' + file.recordValue + '/' + file.tempName
      );
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const downloadLink = document.createElement('a');
      downloadLink.href = url;
      downloadLink.download = file.name;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
      toast.error(<BasicTemplate success={false} text={'Download failed!'} />);
    } finally {
      setItemDownLoading(-1);
    }
  };

  return {
    uploadedFiles,
    itemDownLoading,
    onFileDownload,
    loadFiles
  };
};

export { useUploadByRecordValue, useDownloadByTraineeFiles };
